module.exports = __webpack_public_path__ + "img/indigent3_7-8-2021.041c8f38.jpg";